export default __webpack_public_path__ + "static/media/G0430_Heart_Failure_Algorithm.1705669080000.557c6427.jpg";